import { motion } from "framer-motion";

export default function Quote() {
  return (
    <section className="relative overflow-hidden py-28 sm:py-36">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[28rem] w-[28rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-blaze/15 blur-3xl" />
      <div className="mx-auto max-w-5xl px-5 text-center sm:px-8">
        <motion.blockquote
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          data-testid="cpmc-quote-block"
        >
          <p className="font-display text-3xl font-bold leading-tight tracking-tight sm:text-4xl">
            « On nous a dit que ce n'était pas{" "}
            <span className="text-outline">possible</span>.
            <br />
            Nous, on vous montre
            <br />
            <span className="relative inline-block">
              <span className="relative z-10">que si</span>
              <span className="absolute -bottom-1 left-0 z-0 h-3 w-full bg-sun/80" />
            </span>{" "}
            »
          </p>
          <footer className="mt-8 font-mono text-xs uppercase tracking-[0.25em] text-ink/50">
            Les précurseurs
          </footer>
        </motion.blockquote>
      </div>
    </section>
  );
}
